import * as Yup from "yup";
import { transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { CampaignSchema } from "model/_base";

// Yup Schemas
export const CampaignsSchema = Yup.object().shape({
  data: Yup.array().of(CampaignSchema),
  pagination: PaginationSchema,
});

export class CampaignsModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      console.log(json);
      const model = CampaignsSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      console.log(model);
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
